<div class="flex h-[60px] flex-row items-center justify-between">
  <div [ngClass]="{ 'w-[5%]': hasLeftSpacing }"></div>
  @if (shouldShowDelete) {
    <button mat-raised-button class="!h-10 !p-0" [disabled]="isPending" (click)="emit()">
      @if (isPending) {
        <mat-spinner diameter="25" />
      } @else {
        <mat-icon class="!mx-0 !text-4xl" inline="true">delete</mat-icon>
      }
    </button>
  }
  <div [ngClass]="{ 'w-[5%]': hasLeftSpacing }"></div>
  <div class="flex h-full w-full items-center text-base">
    <span [attr.notranslate]="shouldTranslate ? null : true">{{ val }}</span>
  </div>
</div>
